import styled, { css } from 'styled-components';
import { Collapsible, FlexColumn } from '@equifinance/shared';
import { Insolvency } from '../../../../contexts/credit';
import EquifaxDetails from '../EquifaxDetails/EquifaxDetails';
import { withExpandableRowErrors } from '../../../Errors/ExpandableRowErrors';
import { EquifaxAccordionHeaderShadow } from '../CreditDetails';
import ConsolidationInsolvencyDetails from '../../Consolidation/ConsolidationInsolvencyDetails/ConsolidationInsolvencyDetails';
import InsolvencyDebtDetails from './InsolvencyDebtDetails';

const Container = styled(FlexColumn)` ${({ theme }) => `
  padding: ${theme.padding[4]};
  gap: ${theme.padding[4]};
  background: ${theme.colours.neutral[9]};
`}`;

const collapsibleWrapperCss = css`
  padding: 0;
`.toString();

export function InsolvencyDetails({ data }: { data: Insolvency }) {
  const insolvencyItem = data;

  return (
    <Container>
      <InsolvencyDebtDetails insolvency={insolvencyItem} />
      <ConsolidationInsolvencyDetails data={insolvencyItem} />
      {insolvencyItem?.isEquifax && (
        <Collapsible
          id={`${insolvencyItem?.id}-credit-details`}
          title="Credit details"
          level={2}
          bodyCss={collapsibleWrapperCss}
        >
          <EquifaxAccordionHeaderShadow />
          <EquifaxDetails insolvencyItem={insolvencyItem} />
        </Collapsible>
      )}
    </Container>
  );
}

export default withExpandableRowErrors(InsolvencyDetails);
